import { Click, ClickType, Impression } from '@fiverr-private/bianka_js';
import { getContext } from '@fiverr-private/fiverr_context';
import { bianka } from '@fiverr-private/obs';

const PAGE_NAME = 'listing';

export const reportJoinProRewardsBannerClick = () => {
    const { pageCtxId, userId } = getContext();

    bianka.reportActivity<Click>({
        type: Click,
        event: {
            type: 'clicked_on_join_the_rewards_program',
            clickType: ClickType.LEFT,
            user: {
                id: userId as number,
            },
            page: {
                ctxId: pageCtxId,
                name: PAGE_NAME,
            },
        },
    });
};

export const reportJoinProRewardsBannerCloseClick = () => {
    const { pageCtxId, userId } = getContext();

    bianka.reportActivity<Click>({
        type: Click,
        event: {
            type: 'clicked_on_close_eligibility_upgrade_banner',
            clickType: ClickType.LEFT,
            user: {
                id: userId as number,
            },
            page: {
                ctxId: pageCtxId,
                name: PAGE_NAME,
            },
        },
    });
};

export const reportJoinProRewardsBannerImpression = () => {
    const { pageCtxId, userId } = getContext();

    bianka.reportActivity<Impression>({
        type: Impression,
        event: {
            type: 'viewed_eligibility_upgrade_banner',
            user: {
                id: userId as number,
            },
            page: {
                ctxId: pageCtxId,
                name: PAGE_NAME,
            },
        },
    });
};
